const {v4: uuidv4} = require("uuid");

export const Service = {
    DOMAIN: (window as any).chaiyoGlobalConfig.lineConnectBaseUrl,
    STRAPI: (window as any).chaiyoGlobalConfig.strapi,
    CHAIYO_WEB: (window as any).chaiyoGlobalConfig.chaiyo_web
};

export const StaticContent = Service.CHAIYO_WEB + 'static-contents';

export const StaticContentApi = {
    SERVICE_PROVIDER: StaticContent + '/service-provider',
    PAYMENT_CHANNEL: StaticContent + '/payment-channel',
}


export const ContentApi = {
    TERM_CONDITION: `${Service.STRAPI}/term-and-condition`,
}

export const ServiceApi = {
    VERIFICATION: Service.DOMAIN + "v1/line-connect/onboarding/verification",
    OTP_CONFIRM : Service.DOMAIN + "v1/line-connect/onboarding/otp/confirmation",
    LIST_ACCOUNT: Service.DOMAIN + "v1/line-connect/onboarding/profiles/getAccounts",
    REG_ACCOUNT : Service.DOMAIN + "v1/line-connect/onboarding/profiles/registerAccounts",
    LOAN_DETAIL : Service.DOMAIN + "v1/line-connect/loanAccount/details",

    CODE_GENERATE : Service.DOMAIN + "v1/payment/scan/generation",
    DEEP_LINK_GEN : Service.DOMAIN + "v1/payment/deeplink/generation",
    UNLINK_ACCOUNT : Service.DOMAIN + "v1/line-connect/cancel/loanAccount",

};

export const ApiConfig = {
    headers: {
        "Content-Type": "application/json",
        requestUID: uuidv4(),
        resourceOwnerId: "1qaz2wsx3edc"
    },
};
